import { IFolderCreateRecord, IFolderData } from "common/records/Folder";
import { ActionsUnion } from "common/reducers/UtilsTypes";
import { createAction } from "common/reducers/Utils";

export const FETCH_FOLDER = "@folders/FETCH_FOLDER";
export const FETCH_FOLDERS = "@folders/FETCH_FOLDERS";
export const RECEIVE_FOLDER = "@folders/RECEIVE_FOLDER";
export const SET_FOLDER_LOADED = "@folders/SET_FOLDER_LOADED";
export const REMOVE_FOLDER = "@folders/REMOVE_FOLDER";
export const RESET_FOLDER = "@folders/RESET_FOLDER";
export const RECEIVE_FOLDERS = "@folders/RECEIVE_FOLDERS";
export const EDIT_NAME = "@folders/EDIT_NAME";
export const EDIT_SORT_ORDER = "@folders/EDIT_SORT_ORDER";
export const CREATE_FOLDER = "@folders/CREATE_FOLDER";

export const FolderActions = {
  fetchFolder: (id: number) => createAction(FETCH_FOLDER, { id }),
  receiveFolder: (folder: Partial<IFolderData>) => createAction(RECEIVE_FOLDER, { folder }),
  createFolder: (folderParentId: number, createParams: IFolderCreateRecord) =>
    createAction(CREATE_FOLDER, { folderParentId, createParams }),
  editName: (folderId: number, name: string) => createAction(EDIT_NAME, { folderId, name }),
  editSortOrder: (folderId: number, sortOrder: number) => createAction(EDIT_SORT_ORDER, { folderId, sortOrder }),
  setFolderLoaded: (id: number) => createAction(SET_FOLDER_LOADED, { id }),
  removeFolder: (id: number) => createAction(REMOVE_FOLDER, { id }),
  resetFolder: (id: number) => createAction(RESET_FOLDER, { id }),
  receiveFolders: (folders: IFolderData[]) => createAction(RECEIVE_FOLDERS, { folders }),
};

export type FolderActions = ActionsUnion<typeof FolderActions>;
